import { render, staticRenderFns } from "./DepartmentInfo.vue?vue&type=template&id=230cd98f&scoped=true&"
import script from "./DepartmentInfo.vue?vue&type=script&lang=js&"
export * from "./DepartmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentInfo.vue?vue&type=style&index=0&id=230cd98f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230cd98f",
  null
  
)

export default component.exports